import api from '../../../../api/client'
import { invalidateEntity } from '../../../../api/cacheInvalidation'

export async function listCompanies(params) {
  const { data } = await api.get('/companies/', { params })
  return data
}

export async function getCompanyDetail(companyId) {
  const { data } = await api.get(`/companies/${companyId}`)
  return data
}

export async function createCompany(payload) {
  const { data } = await api.post('/companies/', payload)
  invalidateEntity.company()
  return data
}

export async function updateCompany(companyId, payload) {
  const { data } = await api.put(`/companies/${companyId}`, payload)
  invalidateEntity.company()
  return data
}

export async function uploadCompanyLogo(companyId, file) {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post(`/companies/${companyId}/logo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  invalidateEntity.company()
  return data
}

export async function archiveCompany(companyId) {
  const { data } = await api.post(`/companies/${companyId}/archive`)
  invalidateEntity.company()
  return data
}

export async function approveCompany(companyId) {
  const { data } = await api.patch(`/companies/${companyId}/approve`)
  invalidateEntity.company()
  return data
}

export async function rejectCompany(companyId) {
  const { data } = await api.patch(`/companies/${companyId}/reject`)
  invalidateEntity.company()
  return data
}

export async function bulkApproveCompanies(payload) {
  const { data } = await api.patch('/companies/bulk-approve', payload)
  invalidateEntity.company()
  return data
}

export async function bulkRejectCompanies(payload) {
  const { data } = await api.patch('/companies/bulk-reject', payload)
  invalidateEntity.company()
  return data
}
